export default __webpack_public_path__ + "static/media/background.aee2412a.jpeg";